import type {
  ExportJobItem,
  CreateExportJobInput,
  PaginatedResponse,
} from "@/lib/api/types"

function sleep(ms: number) {
  return new Promise((r) => setTimeout(r, ms))
}

function nowIso() {
  return new Date().toISOString()
}

let jobCounter = 0

const data: ExportJobItem[] = [
  {
    job_id: "exp_001",
    status: "COMPLETED",
    attempt_count: 1,
    created_at: "2024-06-10T10:00:00Z",
    completed_at: "2024-06-10T10:05:00Z",
    download_url: "/mock/download/exp_001",
  },
  {
    job_id: "exp_002",
    status: "FAILED",
    attempt_count: 3,
    created_at: "2024-06-11T14:30:00Z",
    completed_at: null,
    download_url: null,
  },
]

/**
 * Simulate job progression from CREATED -> PROCESSING -> COMPLETED
 */
function simulateJobProgression(job: ExportJobItem) {
  // After 500ms, set to PROCESSING
  setTimeout(() => {
    if (job.status === "CREATED") {
      job.status = "PROCESSING"
      job.attempt_count = 1
    }
  }, 500)

  // After 1500ms, set to COMPLETED
  setTimeout(() => {
    if (job.status === "PROCESSING") {
      job.status = "COMPLETED"
      job.completed_at = nowIso()
      job.download_url = `/mock/download/${job.job_id}`
    }
  }, 1500)
}

export async function createExportJob(
  input: CreateExportJobInput
): Promise<ExportJobItem> {
  await sleep(200)

  jobCounter++
  const newJob: ExportJobItem = {
    job_id: `exp_new_${jobCounter}`,
    status: "CREATED",
    attempt_count: 0,
    created_at: nowIso(),
    completed_at: null,
    download_url: null,
  }

  // Store input reference (not persisted in MVP mock)
  void input

  data.unshift(newJob)
  simulateJobProgression(newJob)

  return newJob
}

export async function listExportJobs(params?: {
  page?: number
  page_size?: number
}): Promise<PaginatedResponse<ExportJobItem>> {
  const page = params?.page ?? 1
  const page_size = params?.page_size ?? 25

  await sleep(200)

  return {
    items: data.slice((page - 1) * page_size, page * page_size),
    page,
    page_size,
    total: data.length,
  }
}
